import { useState } from 'react';
import {
    ENTER_VENDOR_NAME_ERROR,
    SUBTOTAL_ERROR,
    BILL_DATE_ERROR,
    DEPARTMENT_ERROR,
    DESCRIPTION_ERROR,
    SELECT_ITEM_ERROR,
    AMOUNT_ERROR,
    MINIMUM_AMOUNT_ERROR,
    UPLOAD_DOCUMENT_ERROR,
    FILE_IMAGE_UPLOAD_ERROR,
    UPLOAD_MAX_SIZE_ERROR,
    FUND_SELECTION_ERROR,
    INSUFFICIENT_FUND_ERROR,
    INVALID_BILL_DATE_ERROR
} from '../utils/helpers/globalErrorMessage';

const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const MAX_FILE_SIZE = 2 * 1024 * 1024;

const PettyCashValidation = () => {
    const [errors, setErrors] = useState({});

    const validateFundSelection = (selectedFundNumbers, subTotalLineLevel, fundListData) => {
        if (!fundListData || fundListData.length === 0) {
            return true;
        }

        const availableFunds = fundListData.filter(fund => fund.RemainingAmount > 0);

        if (availableFunds.length === 0) {
            return true;
        }

        if (!selectedFundNumbers || selectedFundNumbers.length === 0) {
            return FUND_SELECTION_ERROR;
        }

        const totalSelectedAmount = selectedFundNumbers.reduce(
            (sum, fund) => sum + fund.remainingAmount, 0
        );

        const allFundsSelected = availableFunds.every(availableFund =>
            selectedFundNumbers.some(selected => selected.fundId === availableFund.id)
        );

        if (allFundsSelected) {
            return true;
        }

        if (totalSelectedAmount < subTotalLineLevel) {
            return INSUFFICIENT_FUND_ERROR;
        }

        let remainingAmount = subTotalLineLevel;
        let requiredFunds = 0;

        const sortedFunds = [...selectedFundNumbers].sort((a, b) => a.remainingAmount - b.remainingAmount);

        for (const fund of sortedFunds) {
            if (remainingAmount <= 0) break;
            const fundAmount = Math.min(fund.remainingAmount, remainingAmount);
            remainingAmount -= fundAmount;
            requiredFunds++;
        }

        return true;
    };

    // const isValidBillDate = (dateString, currentDate) => {
    //     if (!dateString) return false;

    //     const inputDate = new Date(dateString);
    //     const today = new Date(currentDate);

    //     const inputYear = inputDate.getFullYear();
    //     const inputMonth = inputDate.getMonth();
    //     const currentYear = today.getFullYear();
    //     const currentMonthIndex = today.getMonth();

    //     if (inputYear !== currentYear) return false;

    //     if (inputMonth < currentMonthIndex) return true;

    //     if (inputMonth === currentMonthIndex && inputDate <= today) return true;

    //     return false;
    // };

    const validateForm = (itemDescriptionLineLevel, subTotalLineLevel, selectedFundNumbers, fundListData) => {
        let errors = {};
        let formIsValid = true;

        const currentDate = new Date();
        const currentISODate = currentDate.toISOString().split('T')[0];

        if (!subTotalLineLevel || isNaN(subTotalLineLevel) || subTotalLineLevel <= 0) {
            formIsValid = false;
            errors.subTotalLineLevel = SUBTOTAL_ERROR;
        }

        const fundValidationResult = validateFundSelection(selectedFundNumbers, subTotalLineLevel, fundListData);
        if (fundValidationResult !== true) {
            formIsValid = false;
            errors.fundSelection = fundValidationResult;
        }

        itemDescriptionLineLevel.forEach((item, index) => {
            const lineItemErrors = {};

            if (!item.vendorName.trim()) {
                formIsValid = false;
                lineItemErrors.vendorName = ENTER_VENDOR_NAME_ERROR;
            }

            if (!item.itemId) {
                formIsValid = false;
                lineItemErrors.itemId = SELECT_ITEM_ERROR;
            }

            if (!item.billDate) {
                formIsValid = false;
                lineItemErrors.billDate = BILL_DATE_ERROR;}
            // } else if (!isValidBillDate(item.billDate, currentISODate)) {
            //     formIsValid = false;
            //     lineItemErrors.billDate = INVALID_BILL_DATE_ERROR;
            // }

            if (!item.amount) {
                formIsValid = false;
                lineItemErrors.amount = AMOUNT_ERROR;
            } else if (parseFloat(item.amount) <= 0) {
                formIsValid = false;
                lineItemErrors.amount = MINIMUM_AMOUNT_ERROR;
            }

            if (!item.description.trim()) {
                formIsValid = false;
                lineItemErrors.description = DESCRIPTION_ERROR;
            }

            if (!item.departmentId) {
                formIsValid = false;
                lineItemErrors.departmentId = DEPARTMENT_ERROR;
            }

            const hasExistingFile = item.existingFileName || item.existingFilePath;
            const hasNewFile = item.attachDoc && item.attachDoc.length > 0;

            if (!hasExistingFile && !hasNewFile) {
                formIsValid = false;
                lineItemErrors.attachDoc = UPLOAD_DOCUMENT_ERROR;
            }
            else if (hasNewFile && !hasExistingFile) {
                const file = item.attachDoc[0];

                if (!file) {
                    formIsValid = false;
                    lineItemErrors.attachDoc = UPLOAD_DOCUMENT_ERROR;
                } else {
                    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
                        formIsValid = false;
                        lineItemErrors.attachDoc = FILE_IMAGE_UPLOAD_ERROR;
                    }

                    if (file.size > MAX_FILE_SIZE) {
                        formIsValid = false;
                        lineItemErrors.attachDoc = UPLOAD_MAX_SIZE_ERROR;
                    }
                }
            }

            if (Object.keys(lineItemErrors).length > 0) {
                if (!errors.itemDescriptionLineLevel) {
                    errors.itemDescriptionLineLevel = {};
                }
                errors.itemDescriptionLineLevel[index] = lineItemErrors;
            }
        });

        setErrors(errors);
        return formIsValid;
    };

    return { errors, setErrors, validateForm };
};

export default PettyCashValidation;